import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { BellRing } from 'lucide-react';
import { FleetEscalationSettings } from './FleetEscalationSettings';

export const Route = createFileRoute('/console/$orgId/configuration/fleet/escalations')({
    staticData: {
        // The fleet module is the per-tenant switch for this page (CUR-1049):
        // an organisation that does not run fleet never sees it.
        metadata: {
            title: 'Escalations',
        },
        ui: {
            icon: BellRing,
            title: 'Escalations',
            subtitle:
                'Email the account manager when a fleet motor claim stalls. Only exceptions are sent — normal progress is visible in the portal and generates no email.',
            menuDescription: 'Configure exception escalation emails for fleet claims',
        },
        modules: ['fleet'],
        permissions: ['settings:update'],
    },
    component: ConfigurationFleetEscalations,
});

function ConfigurationFleetEscalations() {
    return (
        <PageController route={Route}>
            <FleetEscalationSettings />
        </PageController>
    );
}
